<template>
	<div class="form-snippet-list">
		<ul class="form-snippet-list__results" v-if="!showNoResults">
			<li
				class="form-snippet-list__results-item"
				v-for="form in forms"
				:key="form.id"
				:id="`${form.id}_form`"
			>
				<SnippetCardForm :form="form" />
			</li>
		</ul>

		<NoResults v-if="showNoResults" />
	</div>
</template>

<script>
import NoResults from '@/site-components/no-results/no-results';
import SnippetCardForm from '@/views/code-manager/form-snippet-card';

export default {
	name: 'FormSnippetList',
	components: {
		NoResults,
		SnippetCardForm
	},
	props: {
		forms: {
			type: Array
		}
	},

	computed: {
		showNoResults() {
			return this.forms.length === 0;
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * [Description]
    * Code Manager Codes Modal
    * Can use SCSS variables = TRUE
	* BASE
*/

/*------------------------------------*\
  #BASE
\*------------------------------------*/
.form-snippet-list {
	font-size: $default-font-size - 2px;

	@include mq($from: md) {
		max-height: calc(87vh - 320px);
	}

	&__results-item {
		list-style: none;
		padding: $padding-md 0;
		word-break: break-all;

		&:first-child {
			padding-top: 0;
		}
	}
}
</style>
